<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">会员价格<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>店铺名称</label>
              <el-select v-model="shopId" placeholder="Select" class="select-item">
                <el-option v-for="item in shopIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>服务类型</label>
              <el-select v-model="serviceType" placeholder="Select" class="select-item">
                <el-option v-for="item in serviceTypeArray" :key="item.serviceType" :label="item.name" :value="item.serviceType">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>项目名称</label>
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <!--            <el-checkbox v-model="limitState" style="margin-left: 8px;">有限制</el-checkbox>-->
            </div>
          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
              <!--            <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>-->
            </div>
          </div>

        </div>
      </div>
      <div class="content-main">
        <!--        <p class="content-title" style="padding-bottom: 16px;">用户权限</p>-->
        <div class="content-button">
          <div>
            <el-button type="primary" @click="resetAll" size="default">重置</el-button>
          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              size="default"
              border
              @cell-click="showEdit"
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="" label="服务类型" v-if="checkColList.indexOf('服务类型') > -1" width="100em">
              <template #default="scope">
                <p>{{scope.row.projectService.name}}</p>
              </template>
            </el-table-column>
            <el-table-column property="projectName" label="项目（原价格）" v-if="checkColList.indexOf('项目（原价格）') > -1">
              <template #default="scope">
                {{ scope.row.projectName }}<span>（{{scope.row.price}}）</span>
              </template>
            </el-table-column>
            <el-table-column property="" label="500账户" class-name="cursor" v-if="checkColList.indexOf('500账户') > -1">
              <template #default="scope">
                <div v-if="scope.row.isPrivilege">
                  <p v-if="!scope.row.show1">{{ scope.row.wallet1 }}</p>
                  <el-input v-else v-model="scope.row.wallet1" @focusout="inputChange(scope.row, 1)"><template #suffix>元</template></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="name" label="1000账户" class-name="cursor" v-if="checkColList.indexOf('1000账户') > -1">
              <template #default="scope">
                <div v-if="scope.row.isPrivilege">
                  <p v-if="!scope.row.show2">{{ scope.row.wallet2 }}</p>
                  <el-input v-else v-model="scope.row.wallet2" @focusout="inputChange(scope.row, 2)"><template #suffix>元</template></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="name" label="1500账户" class-name="cursor" v-if="checkColList.indexOf('1500账户') > -1">
              <template #default="scope">
                <div v-if="scope.row.isPrivilege">
                  <p v-if="!scope.row.show3">{{ scope.row.wallet3 }}</p>
                  <el-input v-else v-model="scope.row.wallet3" @focusout="inputChange(scope.row, 3)"><template #suffix>元</template></el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column property="name" label="2500账户" class-name="cursor" v-if="checkColList.indexOf('2500账户') > -1">
              <template #default="scope">
                <div v-if="scope.row.isPrivilege">
                  <p v-if="!scope.row.show4">{{ scope.row.wallet4 }}</p>
                  <el-input v-else v-model="scope.row.wallet4" @focusout="inputChange(scope.row, 4)"><template #suffix>元</template></el-input>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {
  getShopProjectPricePageList,
  updateShopProjectPrice,
  resetShopProjectPrice,
  listProjectServiceType
} from "@/api/url";
// import shopDiscountDialog from "@/views/shop/components/shopDiscountDialog";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";

export default {
  name: "ShopPrice",
  components: { BtnGroup, SearchComponents, unLock },
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      shopIdArray: JSON.parse(sessionStorage.getItem('ownShopList')),
      shopIdArr:[],
      shopId: '',

      stateArray: [
        {label: '不限', value: -1},
        {label: '待启用', value: 0},
        {label: '已启用', value: 1},
        {label: '已停用', value: 2}
      ],
      state: -1,

      //刷新组
      colList: ['服务类型', '项目（原价格）', '500账户', '1000账户', '1500账户', '2500账户'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '项目名称：', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      serviceTypeArray: [
        {name: '不限', serviceType: -1}
      ],
      serviceTypeList: [],
      serviceType: -1

    }
  },
  methods: {

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.shopId;
      param['serviceType'] = this.serviceType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getShopProjectPricePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.pageDataList.forEach(item => {
            item.wallet1 = item.walletOnePrice
            item.wallet2 = item.walletTwoPrice
            item.wallet3 = item.walletThreePrice
            item.wallet4 = item.walletFourPrice
            item.show1 = false
            item.show2 = false
            item.show3 = false
            item.show4 = false
          })
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    formatTime(time) {
      let timestamp = time
      let newDate = new Date(parseInt(timestamp))
      let y = newDate.getFullYear();
      let m = newDate.getMonth()+1;
      let d = newDate.getDate();
      return  y + '-' + (m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
    },


    showEdit(row, column, cell, event) {
      this.pageDataList.forEach(item => {
        item.show1 = false
        item.show2 = false
        item.show3 = false
        item.show4 = false
      })

      if(column.label == '500账户') {
        row.show1 = true
      }
      if(column.label == '1000账户') {
        row.show2 = true
      }
      if(column.label == '1500账户') {
        row.show3 = true
      }
      if(column.label == '2500账户') {
        row.show4 = true
      }
    },

    inputChange(item, type) {
      if(!item.wallet1 || !item.wallet2 || !item.wallet3 || !item.wallet4) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '价格不能为空',
          type: 'warning'
        });
        item.wallet1 = item.walletOnePrice
        item.wallet2 = item.walletTwoPrice
        item.wallet3 = item.walletThreePrice
        item.wallet4 = item.walletFourPrice
        return false
      }
      let param = {}
      param['id'] = item.id;
      switch (type) {
        case 1 :
          param['price'] = item.wallet1
          break;
        case 2 :
          param['price'] = item.wallet2
          break;
        case 3 :
          param['price'] = item.wallet3
          break;
        case 4 :
          param['price'] = item.wallet4
          break;
      }
      param['type'] = type
      postFormData(updateShopProjectPrice, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            message: msg,
            type: 'success',
            duration: 2000,
          })
          item['show' + type] = false
        }else {
          this.$message({
            message: msg,
            type: 'warning',
            duration: 2000,
          })
        }
      })
    },

    resetAll() {
      this.$confirm('确认重置门店价格？').then(() => {
        let param = {}
        param['id'] = this.shopId;
        postFormData(resetShopProjectPrice, param).then((data) => {
          let {msg, code} = data
          if (code == 200) {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'success'
            });
            this.getPage()
          } else {
            this.$message({
              showClose: true,
              duration: 2000,
              message: msg,
              type: 'warning'
            });
          }
        })
      }).catch(() => {
        // catch error
      })
    },

    getServiceType() {
      getFormData(listProjectServiceType).then((data) => {
        if(data.code == 200) {
          this.serviceTypeList = data.data
          this.serviceTypeList.map((item,index) => {
            if(item.serviceType == 3) {
              this.serviceTypeList.splice(index, 1)
            }
          })
          this.serviceTypeArray = this.serviceTypeArray.concat(this.serviceTypeList)
        }
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getServiceType()
    this.shopId = this.shopIdArray[0].id
    this.getPage();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
